// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"daf751129a7daf73a657","678":"5a0c929b802e3de20bf6","883":"bbe620a78cd95aa5b8a3"}[chunkId] + ".js";
};